import React from 'react';
import { Autocomplete, TextField, Box } from '@mui/material';
import TagChip from './TagChip';

const TagSelector = ({ 
  value = [], 
  onChange, 
  allTags = [], 
  disabled = false,
  label = "Tags",
  placeholder = "Select tags...",
  error = false,
  helperText = ''
}) => {
  const handleChange = (event, newValue) => {
    onChange(newValue);
  };

  return (
    <Autocomplete
      multiple
      id="tag-selector"
      options={allTags}
      getOptionLabel={(option) => option.name}
      value={value}
      onChange={handleChange}
      disabled={disabled}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      ListboxProps={{
        style: {
          maxHeight: 400
        }
      }}
      componentsProps={{
        popper: {
          style: {
            width: 'auto',
            minWidth: '250px'
          }
        }
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          placeholder={placeholder}
          error={error}
          helperText={helperText}
        />
      )}
      renderTags={(tagValue, getTagProps) =>
        tagValue.map((option, index) => (
          <TagChip
            key={option.id}
            tag={option}
            {...getTagProps({ index })}
          />
        ))
      }
      renderOption={(props, option) => (
        <Box
          component="li"
          {...props}
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1
          }}
        >
          <Box
            sx={{
              width: 16,
              height: 16,
              borderRadius: '50%',
              backgroundColor: option.color,
              flexShrink: 0
            }}
          />
          {option.name}
        </Box>
      )}
      ChipProps={{ size: 'small' }}
    />
  );
};

export default TagSelector;

